import * as axios from "axios";
import * as R from "ramda";
import * as ActionTypes from "../../constants/actiontypes/backoffice/aidavie";
import * as urls from "../../constants/webapi/backoffice/aidavie";
import { getAuthenticationUrl } from "../../constants/webapi/auth";

export function fetchAidavieFiles(pageNumber, search, sortBy, sortDesc, operatorId = "", fromCreationDate = "", toCreationDate = "") {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_AIDAVIE_FILES_REQUEST });
		return axios
			.get(urls.aidavieFilesUrl(pageNumber, search, sortBy, sortDesc, operatorId, fromCreationDate, toCreationDate))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_AIDAVIE_FILES_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_AIDAVIE_FILES_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}

export function UpdateOperator(id, operatorId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_OPERATOR_REQUEST });
		return axios
			.patch(urls.aidavieFileByIdUrl(id), { operatorId: operatorId })
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_OPERATOR_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_OPERATOR_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}
